import InlineChoiceComponent from "../inline-choice-component.jsx";
import { h, render } from "preact";
import copy from "fast-copy";
//@ts-ignore
export default class InlineChoicePreviewComponent extends InlineChoiceComponent {

  componentDidMount() {
    this.props.didRender();
    if (!(this.base instanceof HTMLElement)) {
      throw ("expected base to be an html element");
    }

    this.base.querySelectorAll(".inline-choice").forEach(
      /**
       * @param {HTMLSelectElement} inlineChoiceElement
       */
      (inlineChoiceElement) => {
        if (inlineChoiceElement instanceof HTMLSelectElement) {

          var container = document.createElement('SPAN');
          inlineChoiceElement.replaceWith(container);

          let correctResponseGapMatches = this.correctResponseGapMatches(inlineChoiceElement.dataset.gapIdentifier || "", true);
          if (correctResponseGapMatches) {
            if (correctResponseGapMatches.length == 1) {
              render(this.gapAnswer(correctResponseGapMatches), container);
            }
            else {
              render(this.gapPopup(correctResponseGapMatches), container);
            }
          }
          else {
            render(this.noAnswer(), container);
          }
        }
      });
  }

  render() {
    return this.wrapper(this.body());
  }
}
